<div class="flex gap-4" [ngClass]="{'flex': minimized()}">
  <div #textContainer class="text" [ngStyle]="{'-webkit-line-clamp': minimized() ? minimizedRows() : 'unset'}">
    {{text()}}
  </div>

  @if (showLabel()) {
    @if (minimized()) {
      <div class="show-label" (click)="minimized.set(false)">{{'showMore' | transloco}}</div>
    } @else {
      <div class="show-label margin-top-4" (click)="minimized.set(true)">{{'showLess' | transloco}}</div>
    }
  }
</div>
